import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const SomethingWentWrongLoadingTodos: React.FC = (props) => {
  return (
    <Grid
      container
      className={clsx(cssExports.somethingWentWrongContainer, cssExports.somethingWentWrongLoadingTodosContainer)}
      justifyContent="center"
      alignContent="center"
    >
      <Grid container className={cssExports.errorContent} direction="column">
        <Grid item className={cssExports.title}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.SomethingWentWrongLoadingTodos)}
        </Grid>
        <Grid item>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.ErrorBoundaryMessage)}</Grid>
        <Grid item className={cssExports.bottomText}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.ErrorBoundaryFooterMessage)}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SomethingWentWrongLoadingTodos;
